import React from 'react';
import PropTypes from 'prop-types';
import Translations from '../../../translation/translation';

function MissingDimensions({ onClick }) {
    return (
        <Translations
            translationKey="catalog-statusbar-mobile-missing-status-dimensions"
            className="statusbar-mobile__missing-status statusbar-mobile__missing-status--dimensions"
            tagName="div"
            onClick={onClick}
        />
    );
}

MissingDimensions.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export { MissingDimensions };
